'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var wamEvents = exports.wamEvents = {
    sendEvents: {
        authenticate: 'authenticate',
        getCurrentDevice: 'getCurrentDevice',
        registerClient: 'registerClient',
        clientMsg: 'clientMsg'
    },
    receiveEvents: {
        sendCurrentDevice: 'sendCurrentDevice',
        clientMsg: 'clientMsg',
        clientStates: 'clientStates',
        connect: 'connect',
        error: 'error',
        connectError: 'connect_error',
        disconnect: 'disconnect',
        reconnect: 'reconnect'
    },
    connection: {
        offline: 'offline',
        online: 'online'
    },
    analytics: {
        thorDisconnect: 'thorDisconnect',
        online: 'online',
        appsFocus: 'appsFocus',
        windowFocus: 'windowFocus'
    }
};

var socketDisconnectReasons = exports.socketDisconnectReasons = {
    transportClose: 'transport close',
    pingTimeout: 'ping timeout',
    clientNameSpaceDisconnect: 'client namespace disconnect',
    serverNameSpaceDisconnect: 'server namespace disconnect',
    transportError: 'transport error'
};
var wamMsgStatusType = exports.wamMsgStatusType = _defineProperty({
    thorAppsState: {
        loading: 'loading',
        loadingFailed: 'loading_failed',
        loaded: 'loaded',
        appRefreshedStarted: 'appsRefreshStarted',
        cchDefault: 'cchDefault'
    },
    appsPanelInstallAvailabilityStatus: 'appsPanelInstallAvailabilityStatus',
    needConfirmation: 'needConfirmation',
    closeConfirmation: 'closeConfirmation',
    failed: 'Failed',
    waiting: 'Waiting',
    completed: 'Completed',
    inprogress: 'inProgress',
    appIncompatible: 'AppIncompatible',
    appUnknown: 'AppUnknown',
    cancelling: 'Cancelling'
}, 'completed', 'Completed');

var clientTypes = exports.clientTypes = {
    ui: 'ui',
    engine: 'engine'
};

var thorAppsStatesCategory = exports.thorAppsStatesCategory = {
    activeSessions: 'active_sessions',
    availableToInstall: 'available_to_install',
    availableToUpdate: 'available_updates',
    incompatible: 'incompatible',
    incompatibleWithCheckprevious: 'incompatibleWithCheckprevious',
    installed: 'installed',
    updateAllConfirmation: 'updateAllConfirmation'
};

var thorConfirmationTypes = exports.thorConfirmationTypes = {
    uninstallPreferences: 'uninstallpreferences',
    fullAppUpdateConfirmationWithAdvancedOptions: 'fullappupdateconfirmationwithadvancedoptions',
    conflictingProcess: 'conflictingprocess',
    pii: 'pii',
    productunavailable: 'productunavailable',
    incompatible: 'incompatible',
    retryableError: 'retryableerror'
};

var ccHomeCommands = exports.ccHomeCommands = {
    ccHomeToThorCommands: {
        fetchAppsListFromThor: 'getAppsAndServicesList',
        install: 'install',
        update: 'update',
        cancel: 'cancel',
        retry: 'retry',
        launch: 'launch',
        startTrial: 'startTrial',
        updateAll: 'updateAll',
        uninstall: 'uninstall'
    }
};

var wamTimeouts = exports.wamTimeouts = {
    thorConnectionTimeoutOnPageLoad: 10000,
    thorConnectionTimeoutOnCmdExecution: 10000,
    thorConnectionTimoutOnAutoRetrial: 10000,
    thorConnectionTimeoutOnWamInBackground: 180000
};

var cchomeWamConnection = exports.cchomeWamConnection = {
    onErrorReconnectAttempts: 5,
    onDisconnectReconnectAttempts: 5
};

var cchomeThorConnection = exports.cchomeThorConnection = {
    reconnectOnThorDisconnect: {
        noOfRetries: 3,
        retryInterval: 30000
    },
    thorAppsStateCheck: {
        noOfRetries: 100,
        retryInterval: 1000
    },
    reconnectDelayOnOfflineToOnline: 5000 // Not in use right now.
};

var inlineAttemptThroughFirstTimeInstall = exports.inlineAttemptThroughFirstTimeInstall = {
    interval: 12000,
    iterations: 60 // iterations = minutes * 60 * 1000 / interval; default 12 minutes
};
var pingType = exports.pingType = {
    http: 'http',
    httpsPing: 'https_ping',
    httpPing: 'http_ping',
    httpPingInitiateWorkflow: 'http_initiate_workflow'
};
var wamConnectWF = exports.wamConnectWF = {
    v1: 'v1',
    v2: 'v2'
};

var analyticsEvents = exports.analyticsEvents = {
    v2ToV1: 'v2ToV1',
    v1ToV2: 'v1ToV2',
    onGetCurrentDevice: 'onGetCurrentDevice',
    onThorDetectionByClient: 'onThorDetectionByClient',
    onClientRecvThorAppsState: 'onClientRecvThorAppsState',
    onReceiveCurrentDevice: 'onReceiveCurrentDevice',
    onClientRegistratonWithWAM: 'onClientRegistratonWithWAM',
    onClientWAMConnection: 'onClientWAMConnection',
    onCommandProgress: 'onCommandProgress',
    onAppUnknown: 'onAppUnknown',
    trackTime: {
        ccdDetectTimeTaken: 'ccd-detect-time-taken',
        clientWamConnectTimeTaken: 'client-wam-connect-time-taken',
        clientWamAuthenticationTimeTaken: 'client-wam-authenticate-time-taken',
        ccdTriggerTimeTaken: 'ccd-trigger-time-taken',
        v1: {
            getCurrentDeviceTimeTaken: 'get-current-device-time-taken',
            receiveCurrentDeviceTimeTaken: 'receive-current-device-time-taken'
        },
        clientWamRegistrationTimeTaken: 'client-wam-registration-time-taken'
    }
};
var wamUrls = exports.wamUrls = {
    local: 'https://localhost.adobe.com:3000',
    dev: 'https://stage.wam.adobe.com',
    qe: 'https://stage.wam.adobe.com',
    stage: 'https://stage.wam.adobe.com',
    prod: 'https://prod.wam.adobe.com'
};

var FFCUrls = exports.FFCUrls = {
    products: {
        local: 'https://sqe-prstg-ffc.oobesaas.adobe.com',
        dev: 'https://sqe-prstg-ffc.oobesaas.adobe.com',
        qe: 'https://sqe-prstg-ffc.oobesaas.adobe.com',
        stage: 'https://sqe-prstg-ffc.oobesaas.adobe.com',
        prod: 'https://prod-rel-ffc-ccm.oobesaas.adobe.com'
    },
    productUpdateDesc: {
        local: 'https://cdn-stg-ffc.oobesaas.adobe.com',
        dev: 'https://cdn-stg-ffc.oobesaas.adobe.com',
        qe: 'https://cdn-stg-ffc.oobesaas.adobe.com',
        stage: 'https://cdn-stg-ffc.oobesaas.adobe.com',
        prod: 'https://cdn-ffc.oobesaas.adobe.com'
    }
};

var compatibilityStrings = exports.compatibilityStrings = {
    error: { type: 'error', value: 'Cannot be determined' },
    currentSupported: { type: 'currentSupported', value: 'Current version supported' },
    previousSupported: { type: 'previousSupported', value: 'Previous version supported' },
    incompatible: { type: 'incompatible', value: 'Incompatible OS' }
};

var trialTypes = exports.trialTypes = {
    trialActive: 'TRIAL_ACTIVE',
    trialExpired: 'TRIAL_EXPIRED'
};